import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthGuard } from './neoCore/guard/authGuard/auth.guard';
import { InitialDataResolver } from './app-resolve';

const routes: Routes = [
  {
    // path: 'admin',
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    resolve: {
        initialData: InitialDataResolver
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('./neoAuth/neoAuth.module').then(m => m.NeoAuthModule),
  },
  {
    path: 'error',
    loadChildren: () => import('./neoShared/modules/error/error.module').then(m => m.ErrorModule)
  },
  // { path: '', redirectTo: environment.pagina_aterrizaje, pathMatch: 'full'},
  { path: '**',  redirectTo: '/error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes
    , { scrollPositionRestoration: 'enabled' }
    // { enableTracing: true }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
